import { categories } from './constants';
import { CategoryMetadata, MedisanteOrgReport } from './types';

export const chartColor = (category: string) => {
  switch (category) {
    case categories.OK.value:
      return '#32D17E';
    case categories.WARNING.value:
      return '#FECB00';
    case categories.CRITICAL.value:
      return 'rgb(250, 84, 54)';
    case categories.INFO.value:
      return '#808080';
    default:
      return 'inherit';
  }
};

export const shouldShowSignalStrength = (reports: MedisanteOrgReport[]) =>
  reports.some(
    (r) =>
      r.signalStrengthCritical + r.signalStrengthWarning + r.signalStrengthOK >
      0
  );

export const shouldShowAvgSignalStrength = (reports: MedisanteOrgReport[]) =>
  reports.some(
    (r) =>
      r.signalStrengthAverageCritical +
        r.signalStrengthAverageWarning +
        r.signalStrengthAverageOK >
      0
  );

export const shouldShowSyncData = (reports: MedisanteOrgReport[]) =>
  reports.some((r) => r.syncScheduleCritical + r.syncScheduleOK > 0);

export const shouldShowBatteryVoltage = (reports: MedisanteOrgReport[]) =>
  reports.some((r) => r.batteryCritical + r.batteryWarning + r.batteryOK > 0);

export const shouldShowAvgBatteryVoltage = (reports: MedisanteOrgReport[]) =>
  reports.some(
    (r) =>
      r.batteryAverageCritical + r.batteryAverageWarning + r.batteryAverageOK >
      0
  );

export const getChartData = (category: CategoryMetadata, value: number) => ({
  name: category.name,
  key: category.value,
  val: value,
});

export const buildFilterReport = (reports: MedisanteOrgReport[]) => {
  const deviceVersions: string[] = [];
  const deviceModels: string[] = [];
  const bloodUnits: string[] = [];
  const deviceProperties: string[] = [];

  reports.forEach((report) => {
    report.deviceVersions?.forEach((v) => {
      if (!!!deviceVersions.find((g) => g === v)) {
        deviceVersions.push(v);
      }
    });
    report.deviceModels?.forEach((v) => {
      if (!deviceModels.find((d) => d === v)) {
        deviceModels.push(v);
      }
    });
    report.bloodGlucoseUnits?.forEach((v) => {
      if (!bloodUnits.find((d) => d === v)) {
        bloodUnits.push(v);
      }
    });
    report.deviceProperties?.forEach((v) => {
      if (!deviceProperties.find((d) => d === v)) {
        deviceProperties.push(v);
      }
    });
  });

  return {
    deviceModels: deviceModels,
    deviceVersions: deviceVersions,
    bloodGlucoseUnits: bloodUnits,
    deviceProperties: deviceProperties,
  };
};
